import React from "react";
import capitalize from "lodash/capitalize";
import FeatherIcon from "feather-icons-react";
import Row from "antd/es/row";
import "antd/es/row/style";
import Col from "antd/es/col";
import "antd/es/col/style";
import { SwitchToggle } from "../SwitchToggle";

export const ViewAppointmentModalHeader = ({
  appointmentNumber,
  status,
  needsAttention,
  partiallyFilled,
  refetch,
  showToggle,
  isPublishSelected,
  setIsPublishedSelected,
}) => {
  return (
    <div>
      <Row>
        <Col sm={showToggle ? 20 : 24}>
          <span
            style={{ marginRight: "20px" }}
          >{`Appointment #${appointmentNumber}`}</span>
          <span
            className={`status ${status === "completed" || status === "complete"
              ? "Success"
              : partiallyFilled
                ? "partially-filled"
                : status === "pending" && needsAttention
                  ? "needs-attention"
                  : status === "pending"
                    ? "warning"
                    : status === "filled" || status === "assigned"
                      ? "in-progress"
                      : status === "disabled"
                        ? "disabled"
                        : "error"
              }`}
            style={{ marginRight: "10px" }}
          >
            {partiallyFilled
              ? "Partially filled"
              : status === "pending" && needsAttention
                ? "Could not fill"
                : capitalize(status)}
          </span>
          <span style={{ cursor: "pointer", color: "#9299B8", padding: "10px" }} onClick={() => refetch()}>
            <FeatherIcon size={16} icon="rotate-cw" className="anticon" />
          </span>
        </Col>

        <Col sm={4}>
          {showToggle ? <SwitchToggle
            size={"small"}
            copy={<span style={{
              fontSize: "14px",
              lineHeight: "20px",
              alignSelf: "center",
            }}>Publish</span>}
            onChange={(e) => {
              let val = e;
              setIsPublishedSelected(val);
            }}
            isToggled={isPublishSelected}
          /> : null}
        </Col>
      </Row>
    </div>
  );
};
